// @flow

import * as React from 'react';

import type { PreviewVenue } from './types';

type Props = {|
  venue: PreviewVenue,
  className?: string,
  children: React.Node,
  onClickVenueLink?: () => void,
  openInNewTab: boolean
|};

type LinkProps = {|
  href: string,
  target?: string,
  className?: string,
  onClick?: () => void
|};

export default function VenueLink({
  openInNewTab,
  venue,
  className,
  onClickVenueLink,
  children
}: Props): React.Node {
  const linkProps: LinkProps = {
    onClick: onClickVenueLink,
    href: venue.url,
    className
  };

  linkProps.target = openInNewTab ? `venue_${venue.id}` : '_self';

  return (
    <a {...linkProps} data-testid="venue-link">
      {children}
    </a>
  );
}
